@if (showRecorder) {
  <screen-recorder></screen-recorder>
}
<nz-layout class="system-view-app form-field-density-4" [ngClass]="{'theme-alternate': isDarkTheme | async, 'vault-theme': isVault, 'modern-theme': isModern, 'warm-theme': isWarm, 'violet-theme': isViolet, 'orange-theme': isOrange, 'custom-theme': isCustom, 'brasil-theme': isBrasil, 'zorro-theme': isZorro, 'bootstrap-theme': isBootstrap}">
    <nz-header nzTheme="light" class="custom-header">
      <div class="menu-class">
          <span>
              <img *ngIf="!(isDarkTheme|async)" src="assets/image/Logotipo_TemAPI_SemFundo-01.png" class="logimage" />
              <img *ngIf="(isDarkTheme|async)" src="assets/image/Logotipo_TemAPI_SemFundo-02.png" class="logimage" />
          </span>
            <div class="vl"></div>  
            <button nz-button nzType="text" nzSize="large" (click)="toggleSider()" >
                <nz-icon [nzType]="navService.sidenavSmall ? 'menu-unfold' : 'menu-fold'" nzTheme="outline"></nz-icon>
            </button>
          
            @if (hasActiveRoute && this.UserAuthenticationServices.user.iddashboard!=null && this.UserAuthenticationServices.user.iddashboard>0) {
              <div class="vl"></div>
              <nz-icon class="trigger-icon"  nzType="dashboard" (click)="backToDashboard()" [nz-tooltip]="('system.voltaraoashboard'|translateTA)"></nz-icon>
            }
            @if (!hasActiveRoute && this.UserAuthenticationServices.user.iddashboard!=null && this.UserAuthenticationServices.user.iddashboard>0){
              <div class="vl"></div>
              <nz-icon class="trigger-icon" nzType="desktop" (click)="backToRoute()" [nz-tooltip]="('system.voltartabs'|translateTA)"></nz-icon>
            }
            
          <div class="flex-spacer"></div>
          @if(canViewRec){
            <div class="recorder-toggle" >
              <span>{{'system.ativargravador'|translateTA}}</span>
              <nz-switch 
                [nzSize]="'small'"
                [(ngModel)]="showRecorder" >
              </nz-switch>
            </div>
            <div class="vl"></div>   
          }
         <div class="search">
            <form class="search-form" [formGroup]="formLink">
                <div>
                    <nz-input-wrapper class="search-full-width">
                        <input 
                            nz-input 
                            formControlName="linkName" 
                            [placeholder]="'controlk'|translateTA" 
                            #inputResourceFinder
                            
                            aria-label="Busca de Recurso"
                            [nzAutocomplete]="auto">
                            <nz-icon nzInputSuffix nzType="search" />
                    </nz-input-wrapper>
                    <nz-autocomplete 
                        #auto="nzAutocomplete"
                        (selectionChange)="onSelectItem($event)">

                        <nz-auto-option *ngIf="loadingLinks" [nzDisabled]="true">
                          <div class="search-option">
                            <nz-spin nzSimple></nz-spin>
                            <span style="margin-left:8px">{{'loading'|translateTA}}</span>
                          </div>
                        </nz-auto-option>
                         @for (route of linksRoute| async; track trackByRoute) {
                          <nz-auto-option 
                              [nzValue]="route.IDMENU">
                              <div class="search-option">
                                  <div class="search-option-description">{{'menu.'+route.IDMENU|translateTA}}</div>
                                  <div class="flex-spacer"></div>
                                    <nz-icon [nzType]="route.svgIconName!=null?('custom:'+route.svgIconName):route.iconName" />
                              </div>
                          </nz-auto-option>
                        }
                    </nz-autocomplete>
                </div>
            </form>
          </div>
          <div class="vl"></div>
          
          <div class="icon-notification-container">
            <notifications-card  #notif ></notifications-card>
          </div>
          
          
          
          <div class="vl"></div>
          <div nz-dropdown 
               [nzDropdownMenu]="languageMenu" 
               nzPlacement="bottomRight">
            <button nz-button nzType="text" nzSize="large">
              <nz-icon nzType="global"></nz-icon>
            </button>
          </div>
          <nz-dropdown-menu #languageMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="changeLanguage('en-US')">
                <nz-icon nzType="custom:us_1x1" nzTheme="outline"></nz-icon>
                <span class="name-country">English-US</span>
              </li>
              <li nz-menu-item (click)="changeLanguage('pt-BR')">
                <nz-icon nzType="custom:br_1x1" nzTheme="outline"></nz-icon>
                <span class="name-country">Português-BR</span>
              </li>
            </ul>
          </nz-dropdown-menu>
          <div class="vl"></div>
           <div nz-dropdown 
               [nzDropdownMenu]="menu" 
               nzPlacement="bottomRight">
            <button nz-button nzType="text" nzSize="large">
              <nz-icon nzType="custom:temapi"></nz-icon>
            </button>
          </div>
           <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <span class="username">{{userName}}</span>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="openConf()" class="menu-item-class">
                <nz-icon nzType="user" nzTheme="outline"></nz-icon>
                <span class="name-country">{{'profile'|translateTA}}</span>
              </li>
              <li nz-menu-item (click)="logout()" class="menu-item-class">
                <nz-icon nzType="logout" nzTheme="outline"></nz-icon>
                <span class="name-country">{{'logout'|translateTA}}</span>
              </li>
            </ul>
          </nz-dropdown-menu>
      </div>
    </nz-header>
    <nz-layout class="main-layout">
      <nz-sider nzCollapsible
                 [nzTheme]="'light'"
                 [nzWidth]="240"
                 [(nzCollapsed)]="navService.sidenavSmall"
                 [nzTrigger]="null">

        <!-- <ul nz-menu nzMode="inline" [nzTheme]="'light'" class="sider-menu">
          
        </ul> -->
        <div class="sider-menu">
            <system-view-new-item [items]="navItems"></system-view-new-item>
        </div>
      </nz-sider>
      <nz-layout class="inner-layout">
        <nz-content class="main-content">

            @if( UserAuthenticationServices.user.iddashboard!=null && UserAuthenticationServices.user.iddashboard>0 ){
                <main-dashboard class="dashboard-bg"  
                [iddashboard]="UserAuthenticationServices.user.iddashboard" [hidden]="hasActiveRoute">
                </main-dashboard>
            }
        
            <nz-tabs [hidden]="!hasActiveRoute"
              class="main-tab-group" nzType="editable-card" nzHideAdd="true"
              [(nzSelectedIndex)]="selectedTabIndex"
                (nzSelectedIndexChange)="onTabChange($event)"
                
                (nzClose)="closeTab($event)">
                <nz-tab [nzClosable]="true"
                [nzTitle]="titleTemplate"
                *ngFor="let tab of tabService.tabs; let i = index; trackBy: trackByUrl"
                >
                    <ng-template #titleTemplate>
                        <nz-icon [nzType]="tab.svgIconName!=null?('custom:'+tab.svgIconName):tab.iconName" />
                        {{tab.name|translateTA}}
                        
                    </ng-template>   
                    
                    
                </nz-tab>
            </nz-tabs>
            
            <div  [hidden]="!hasActiveRoute" class="tab-content">
              <router-outlet></router-outlet>
            </div>
            
          
        </nz-content>
      </nz-layout>
    </nz-layout>
   
    <nz-footer class="footer">
      Versão Angular: {{version.major}} - Aplicação: {{ versionApp }}
    </nz-footer>
  </nz-layout>

  <!-- Balão dos chamados do próprio usuário. Ele mesmo decide se aparece:
       só nasce quando há chamado em andamento, e some dentro de /chamados. -->
  <chamados-widget></chamados-widget>
  